import { AnyAction } from 'redux';
import { Store } from 'store/index';
import { ThunkDispatch } from 'redux-thunk';
import { setPricesToFetchAction } from 'store/price/slice';
import { cloneDeep } from 'lodash';
import getEncPublicDesignId from 'store/product/selector/getEncPublicDesignId';
import getPricesToFetch from '../selector/getPricesToFetch';
import { PricesToFetch } from '../types';

const setPricesToFetchOperation =
  (pricesToFetch: PricesToFetch) => (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const currentPricesToFetch = getPricesToFetch(store);
    const encPublicDesignId = getEncPublicDesignId(store);
    let newPricesToFetch: PricesToFetch;
    if (currentPricesToFetch) {
      newPricesToFetch = cloneDeep(currentPricesToFetch) as PricesToFetch;
      Object.keys(pricesToFetch).forEach((priceCategory) => {
        if (newPricesToFetch[priceCategory]) {
          newPricesToFetch[priceCategory].productIds.push(...pricesToFetch[priceCategory].productIds);
        } else {
          newPricesToFetch[priceCategory] = {
            categoryId: Number(priceCategory),
            productIds: [],
            encryptedDesignId: encPublicDesignId || '',
          };
          newPricesToFetch[priceCategory].productIds = pricesToFetch[priceCategory].productIds;
        }
        // make productIds uniq
        newPricesToFetch[priceCategory].productIds = [...new Set(newPricesToFetch[priceCategory].productIds)];
      });
    } else {
      newPricesToFetch = pricesToFetch;
    }
    dispatch(setPricesToFetchAction(newPricesToFetch as PricesToFetch));
  };

export default setPricesToFetchOperation;
